import Vue from 'vue'
import Vuex from 'vuex'
import { RootState } from '@/types'
import * as user from '@/store/modules/user'
import * as notification from '@/store/modules/notification'

Vue.use(Vuex)

export default new Vuex.Store<RootState>({
    state: {
        version: process.env.VUE_APP_VERSION,
    },
    modules: {
        user,
        notification,
    },
})
